/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketinvoicenotavailableerror4Inputs */

const en_ticketinvoicenotavailableerror4 = /** @type {(inputs: Ticketinvoicenotavailableerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no invoice for this order yet. Check the details in the ticket settings.`)
};

const de_ticketinvoicenotavailableerror4 = /** @type {(inputs: Ticketinvoicenotavailableerror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese Bestellung gibt es noch keine Rechnung. Prüfe die Angaben in den Ticket-Einstellungen.`)
};

/**
* | output |
* | --- |
* | "There is no invoice for this order yet. Check the details in the ticket settings." |
*
* @param {Ticketinvoicenotavailableerror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketinvoicenotavailableerror4 = /** @type {((inputs?: Ticketinvoicenotavailableerror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketinvoicenotavailableerror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketinvoicenotavailableerror4(inputs)
	return de_ticketinvoicenotavailableerror4(inputs)
});
export { ticketinvoicenotavailableerror4 as "ticketInvoiceNotAvailableError" }